import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../../redux/actions/modal';
import SelectImageForm from './form';

export const IMAGE_CROPPER_MODAL = 'IMAGE_CROPPER_MODAL';

type ImageCropperModalProps = {
  show: boolean;
};

const ImageCropperModal = ({ show }: ImageCropperModalProps) => {
  const dispatch = useDispatch();

  const onHide = () => dispatch(hideModal(IMAGE_CROPPER_MODAL));

  const onSubmit = () => {
    onHide();
  };

  return (
    <Modal centered show={show} onHide={onHide} backdrop="static">
      {/* @ts-expect-error - Modal.Header types since it's not TS */}
      <Modal.Header closeButton>
        <h3 className='secondary'>Change company logo</h3>
      </Modal.Header>
      <SelectImageForm onSubmit={onSubmit} onCancel={onHide} />
    </Modal>
  );
};

export default ImageCropperModal;
